import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const HowToUse = ({ product, instructions }) => ((instructions && instructions.length > 0) ? (
  <ProductPropertyTab title="How to use" product={product}>
    <PropertyList element="ul" like="dec-4">
      {
          instructions.map((item) =>
            // eslint-disable-next-line react/no-danger
            <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
        }
    </PropertyList>
  </ProductPropertyTab>
) : null);

HowToUse.defaultProps = {
  instructions: []
};

HowToUse.propTypes = {
  product: PropTypes.object.isRequired,
  instructions: PropTypes.array
};

export default HowToUse;
